import Vue from 'vue';
import Component from 'vue-class-component';
import yjheader from '@/components/common/yjheader.vue';
import ConditionInsert from './components/ConditionInsert/ConditionInsert';
// tslint:disable-next-line:max-line-length
import ConditionNotTrigger from './components/ConditionNotTrigger/ConditionNotTrigger';
// tslint:disable-next-line:max-line-length
import ConditionTriggered from './components/ConditionTriggered/ConditionTriggered';
/**
 * 条件单
 */
@Component({
  components: {
    yjheader,
    ConditionInsert,
    ConditionNotTrigger,
    ConditionTriggered,
  },
})
export default class Condition extends Vue {
  public name = 'condition';
  public targentId = '';
  public spanState = '3';
  public contractValue = '';
  public goback() {
    this.$router.go(-1);
  }
  public activated() {
    this.$store.commit('selectIndex', 3);
    this.targentId = this.$route.query.targetId;
  }
  public deactivated() {
    this.spanState = '3';
    // beferFooterIndex = 3;
  }
}



// WEBPACK FOOTER //
// ./src/views/condition/Condition.ts